export const PLAN_BASED_CONVERT_LEAVE = "PlanBasedConvertLeave";
export const SUM_ASSURED_BASED = "SumAssuredBased";
export const PLAN_BASED = "PlanBased";
export const PLAN_BASED_OPTIONAL = "PlanBasedOptional";



// WEBPACK FOOTER //
// ./components/employee/shop/constants.js